/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
import React from 'react'
import {
  Grid,
  TextField,
  MenuItem,
  Box,
  Button,
  InputBase,
} from '@material-ui/core'
import Icon from '@mdi/react'
import { mdiPlus } from '@mdi/js'

import colors from '../../../../../../assets/colors'
import filterStylesComponents from '../../../../../../assets/filterComponentsStyles'
import NumberFormatCustom from '../../../../../components/NumberFormat'

// Situação tributária do ISSQN (padrão Nacional - NFSen)
const TRIBUTACAO_ISS_OPTIONS = [
  { value: 1, label: 'Operação tributável' },
  { value: 2, label: 'Imunidade' },
  { value: 3, label: 'Exportação de serviço' },
  { value: 4, label: 'Não incidência' },
]

// Quem recolhe o ISS (padrão Nacional - NFSen)
const TIPO_RETENCAO_ISS_OPTIONS = [
  { value: 1, label: 'Não retido (prestador recolhe)' },
  { value: 2, label: 'Retido pelo tomador' },
  { value: 3, label: 'Retido por intermediário' },
]

const FormFiscalData = ({
  form,
  mask,
  isNational = false,
  enquadramentos,
  enquadramentoFields = [],
  setForm = () => {},
  handleChange = () => {},
  handleEnquadramentoChange = () => {},
  onOpenEnquadramentoModal = () => {},
}) => {
  const filterClasses = filterStylesComponents()

  const renderAliquotaField = ({ required = false } = {}) => (
    <Grid item xs={3}>
      <TextField
        label="Aliquota ISS"
        required={required}
        value={form.aliquota_iss}
        variant="outlined"
        onChange={e =>
          setForm({
            ...form,
            aliquota_iss: e.target.value,
          })
        }
        InputProps={{
          inputComponent: NumberFormatCustom,
          inputProps: {
            suffix: '%',
            style: {
              textAlign: 'left',
              color: colors.textPrimary,
            },
            min: 0,
            max: 100,
          },
        }}
      />
    </Grid>
  )

  const formatEnquadramentoValue = (field, value) => {
    if (value === null || value === undefined || value === '') return null

    if (field.type === 'select') {
      const option = field.options?.find(o => o.value == value)
      return option?.label ?? value
    }

    if (field.type === 'percentage') return `${value}%`

    return value
  }

  const buildEnquadramentoDetails = enquadramento =>
    enquadramentoFields
      .filter(field => field.name !== 'nome')
      .map(field => {
        const value = formatEnquadramentoValue(
          field,
          enquadramento?.[field.name]
        )
        return value === null ? null : `${field.label}: ${value}`
      })
      .filter(Boolean)
      .join(' · ')

  return (
    <>
      <Grid item xs={12}>
        <InputBase
          name="description"
          value={form.description}
          onChange={handleChange}
          placeholder="Descrição"
          multiline
          required
          inputProps={{
            style: {
              minHeight: '169px',
              maxHeight: '200px',
              overflow: 'auto',
            },
          }}
          fullWidth
          style={{
            borderRadius: '10px',
            border: `1px solid ${colors.graylight}`,
            minHeight: '169px',
            padding: '8px 0 8px 8px',
            maxHeight: '200px',
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={3}>
            <TextField
              select
              value={form?.enquadramento_id}
              name="enquadramento_id"
              required
              variant="outlined"
              fullWidth
              label="Enquadramento"
              onChange={handleEnquadramentoChange}
              SelectProps={{
                renderValue: selected =>
                  enquadramentos?.find(e => e?.id == selected)?.nome || '',
              }}
            >
              <MenuItem value="">Selecione...</MenuItem>
              {enquadramentos?.map((enquadramento, index) => {
                const details = buildEnquadramentoDetails(enquadramento)

                return (
                  <MenuItem
                    key={enquadramento?.id}
                    value={enquadramento?.id}
                    index={index}
                  >
                    <Box display="flex" flexDirection="column">
                      <span>{enquadramento?.nome}</span>
                      {details && (
                        <span
                          style={{
                            fontSize: '12px',
                            color: colors.textGray,
                            whiteSpace: 'normal',
                          }}
                        >
                          {details}
                        </span>
                      )}
                    </Box>
                  </MenuItem>
                )
              })}
            </TextField>

            <Button
              className={filterClasses.btnAdd}
              onClick={onOpenEnquadramentoModal}
              style={{ marginTop: '4px' }}
            >
              <Icon path={mdiPlus} size={0.8} />
              Cadastrar enquadramento
            </Button>
          </Grid>

          <Grid item xs={3}>
            <TextField
              label="Valor da Nota:"
              required
              value={form.value}
              variant="outlined"
              onChange={e =>
                setForm({
                  ...form,
                  value: e.target.value,
                })
              }
              fullWidth
              InputProps={{
                inputComponent: NumberFormatCustom,
                inputProps: {
                  prefix: 'R$ ',
                  style: {
                    textAlign: 'left',
                    color: colors.textPrimary,
                  },
                },
              }}
            />
          </Grid>

          {isNational ? (
            <>
              <Grid item xs={3}>
                <TextField
                  select
                  value={form?.tributacao_iss}
                  name="tributacao_iss"
                  required
                  variant="outlined"
                  fullWidth
                  label="Tributação do ISSQN"
                  onChange={handleChange}
                >
                  {TRIBUTACAO_ISS_OPTIONS.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={3}>
                <TextField
                  select
                  value={form?.tipo_retencao_iss}
                  name="tipo_retencao_iss"
                  required
                  variant="outlined"
                  fullWidth
                  label="Retenção do ISSQN"
                  onChange={handleChange}
                >
                  {TIPO_RETENCAO_ISS_OPTIONS.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Alíquota só é relevante na operação tributável (tributacao_iss = 1) */}
              {form?.tributacao_iss == 1 && renderAliquotaField()}
            </>
          ) : (
            <>
              <Grid item xs={3}>
                <TextField
                  select
                  value={form?.iss_retido}
                  name="iss_retido"
                  required
                  variant="outlined"
                  fullWidth
                  label="ISS Retido?"
                  onChange={handleChange}
                >
                  <MenuItem value="">Selecione...</MenuItem>
                  <MenuItem value="true">Sim</MenuItem>
                  <MenuItem value="false">Não</MenuItem>
                </TextField>
              </Grid>

              {form?.iss_retido == 'true' &&
                renderAliquotaField({ required: true })}

              {form?.iss_retido == 'true' && mask == '99.999.999/9999-99' && (
                <Grid item xs={3}>
                  <TextField
                    label="Inscrição Municipal do Tomador"
                    fullWidth
                    variant="outlined"
                    name="inscricao_municipal"
                    value={form?.inscricao_municipal}
                    onChange={handleChange}
                    required
                  />
                </Grid>
              )}
            </>
          )}
        </Grid>
      </Grid>
    </>
  )
}

export default FormFiscalData
